export default __webpack_public_path__ + "static/media/logo.735e77fb.svg";